/*
 * Minimum order amount validation.
 *
 * Configuration (enabled / minimum / message) is rendered from the theme
 * settings into `window.keysouqMinCart` in layout/theme.liquid. This file only
 * adds the helpers used by the cart page and the cart drawer.
 */
(function () {
  const minCart = window.keysouqMinCart || (window.keysouqMinCart = {});

  /* Cart total, in cents, read from the surface that is being checked out. */
  minCart.cartTotal = function (scope) {
    const root = scope || document;
    const holder =
      (root.matches && root.matches('[data-cart-total]') && root) || root.querySelector('[data-cart-total]');
    return holder ? Number(holder.dataset.cartTotal) : NaN;
  };

  minCart.isBelowMinimum = function (totalInCents) {
    if (!minCart.enabled) return false;

    const minimum = Number(minCart.minimum);
    const total = Number(totalInCents);
    if (!minimum || minimum <= 0 || isNaN(total)) return false;

    return total < minimum;
  };

  minCart.showError = function (errorElement) {
    if (!errorElement) return;
    errorElement.textContent = minCart.message || '';
    errorElement.style.display = 'block';
  };

  minCart.hideError = function (errorElement) {
    if (!errorElement) return;
    errorElement.textContent = '';
    errorElement.style.display = 'none';
  };

  /*
   * For buttons that never navigate on their own (Buy Now on a card, which
   * builds the checkout in JS). Returns true when the action must be stopped.
   */
  minCart.blocks = function (totalInCents, errorElement) {
    minCart.hideError(errorElement);
    if (!minCart.isBelowMinimum(totalInCents)) return false;

    minCart.showError(errorElement);
    return true;
  };

  /*
   * Blocks the click and shows the message when the cart is below the minimum.
   * Returns true when checkout is allowed to continue.
   */
  minCart.validate = function (event, scope, errorElement) {
    if (!minCart.enabled) return true;

    minCart.hideError(errorElement);
    if (!minCart.isBelowMinimum(minCart.cartTotal(scope))) return true;

    event.preventDefault();
    event.stopImmediatePropagation();
    minCart.showError(errorElement);
    return false;
  };
})();
